import { darken } from "polished";
import styled from "styled-components";

import SimpleButton from "@/components/Button";

export const ModalErrorContainer = styled.div`
  background-color: ${({ theme }) => theme.background};
  box-shadow: 0px 2px 5px ${({ theme }) => theme.shadow};
  max-width: 600px;
  max-height: 830px;
  min-width: 300px;
  margin: 20px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ModalErrorHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 15px;
  padding: 20px;
`;

export const ModalErrorTitle = styled.span`
  font-size: 19px;
  line-height: 19px;
  font-weight: 600;
`;

export const ModalErrorCloseButton = styled.button`
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg.icon {
    cursor: pointer;
    width: 16px;
    height: 16px;
    fill: ${({ theme }) => theme.text};
  }
`;

export const ModalErrorFooter = styled.div`
  display: flex;
  padding: 20px;
  background-color: ${({ theme }) => darken(0.02, theme.background)};
`;

export const ModalErrorCancelButton = styled(SimpleButton)`
  gap: 10px;
  padding: 12px 15px !important;
  border-radius: 12px;
  flex: 1;
`;

export const ModalErrorCodeContainer = styled.div`
  gap: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  flex: 1;
  margin: auto;
  max-width: 100%;
  padding: 20px;

  & > svg.icon {
    width: 50px;
    height: 50px;
    flex: none;
    fill: ${({ theme }) => theme.error};
  }
`;

export const ModalErrorCode = styled.div`
  font-size: 15px;
  line-height: 18px;
  font-weight: 600;
  white-space: pre-wrap;
  word-wrap: break-word;
  text-align: center;
  max-width: 100%;
  color: ${({ theme }) => theme.error};
`;

export const ModalErrorResponseData = styled.span`
  font-size: 14px;
  font-weight: 500;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: 100%;
`;
